import { post } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const updateOfferHeader = offerHeader => {
  return post(`${url}/leasingoffers/${offerHeader.documentId}/${offerHeader.siteId}/headers`, offerHeader);
};

const exp = {
  updateOfferHeader
};
export default exp;
